<template>
  <div class="chart-type-switcher">
    <r-title type="subtitle-2" style="margin-bottom:8px">
      {{ $t("chart-change") }}
    </r-title>
    <ul class="chart-type-switcher__list">
      <li
        v-for="(item, i) in charts.types"
        :key="item"
        class="chart-type-switcher__item"
      >
        <a @click="openChart(item)" :class="{ active: activeType[i] }">
          <el-tooltip
            :open-delay="1000"
            effect="light"
            :content="item"
            placement="bottom"
          >
            <r-icon :name="item" :size="24" />
          </el-tooltip>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chartType: "",
      charts: {
        types: {
          basic: "basic",
          bar: "bar",
          barX: "bar-x",
          pie: "pie",
          doughnut: "doughnut",
          pieRose: "pie-rose",
          polar: "polar",
          scatter: "scatter"
        }
      },
      activeType: {
        basic: false,
        bar: false,
        pie: false,
        doughnut: false,
        barX: false,
        scatter: false,
        polar: false,
        pieRose: false
      }
    };
  },
  watch: {
    "$store.state.charts.activeChart": {
      handler: function(value) {
        let charts = Object.keys(value);
        if (charts.length && charts[0] !== "updated") {
          switch (value[charts[0]].type) {
            case "bar-x":
              this.chartType = "barX";
              break;
            case "pie-rose":
              this.chartType = "pieRose";
              break;
            default:
              this.chartType = value[charts[0]].type;
              break;
          }
        } else {
          this.chartType = "";
        }
        this.setActiveType();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async openChart(chartType) {
      const activeChart = Object.keys(this.$store.state.charts.activeChart);
      let activeTab = this.$store.state.charts.activeTab.tab;
      if (!activeTab) {
        activeTab = 1;
        this.$store.commit("ADD_CHART_TAB", activeTab);
      }
      if (activeChart.length && activeChart[0] !== "updated") {
        const chartId = activeChart[0];
        this.$store.commit("CHANGE_CHART_TYPE", {
          tab: activeTab,
          chartId,
          chartType
        });
      }

      try {
        await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
      } catch (e) {
        console.log(e);
      }
    },
    setActiveType() {
      for (let key in this.activeType) {
        if (key === this.chartType) {
          this.activeType[key] = true;
        } else {
          this.activeType[key] = false;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.chart-type-switcher {
  padding: 8px 8px 16px;
  border-radius: var(--border-radius);
  &__list {
    list-style: none;
    display: flex;
    border-radius: var(--border-radius);
    align-items: center;
    flex-wrap: wrap;
    max-width: 228px;
  }
  &__item {
    text-align: center;
    margin-right: 6px;
    &:last-child() {
      margin-right: 0;
    }
    a {
      padding: 6px;
      cursor: pointer;
      margin: auto;
      position: relative;
      display: block;
      border-radius: var(--border-radius);
      box-sizing: border-box;
      border: 1px solid;
      border-color: transparent;
      &.active {
        background-color: var(--accent_selected) !important;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "chart-change": "Изменить тип графика"
  },
  "en": {
    "chart-change": "Change chart type"
  }
}
</i18n>
